// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3bc9ed0f","455":"9795fd46","583":"89a1cb3b","977":"c03936ea"}[chunkId] + ".chunk.js";
};